var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal"},[_c('a',{on:{"click":_vm.hideModal}},[_c('v-icon',{staticClass:"modal__close-icon",attrs:{"name":"times","scale":"1.6"}})],1),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }